var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreatePlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78329 0H8.21353C8.07399 0 8.00422 0.0666667 8.00422 0.2V8.05H0.208326C0.0687909 8.05 -0.000976562 8.11667 -0.000976562 8.25V9.75C-0.000976562 9.88333 0.0687909 9.95 0.208326 9.95H8.00422V17.8C8.00422 17.9333 8.07399 18 8.21353 18H9.78329C9.92283 18 9.9926 17.9333 9.9926 17.8V9.95H17.7897C17.9293 9.95 17.999 9.88333 17.999 9.75V8.25C17.999 8.11667 17.9293 8.05 17.7897 8.05H9.9926V0.2C9.9926 0.0666667 9.92283 0 9.78329 0Z",
    fill: "#4A4B66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePlus);
export default __webpack_public_path__ + "static/media/createPlus.4209a63d5db4d26c204dd87f4fcce4a4.svg";
export { ForwardRef as ReactComponent };